var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"kontainer"},[_c('GSTC',{attrs:{"config":_vm.config}}),_vm._v(" "+_vm._s(_vm.config.chart.items)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }